import { ref} from "vue";

const screenWidth = ref(window.innerWidth);

async function checkScreen() {
    const updateScreenWidth = () => {
      screenWidth.value = window.innerWidth;
    };
    
    window.addEventListener("resize", updateScreenWidth);

    return () => {
        window.removeEventListener("resize", updateScreenWidth);
    };
}

export { checkScreen, screenWidth };


